import {IMCTextEntities} from '../../../api/proto';

export default function filterDuplicateTextEntities(textEntities: IMCTextEntities[] | null): IMCTextEntities[] {
  if (!textEntities) {
    return [];
  }

  const uniqueTextEntities = new Map<string, IMCTextEntities>();

  textEntities.forEach((entity) => {
    const key = `${entity.offset?.toString()}-${entity.length?.toString()}-${entity.type?.toString()}`;
    if (!uniqueTextEntities.has(key)) {
      uniqueTextEntities.set(key, entity);
    }
  });

  return Array.from(uniqueTextEntities.values());
}